import React from 'react'

export default function ArrowTop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="436.717px"
      height="436.717px"
      viewBox="0 0 436.717 436.717"
      enableBackground="0 0 436.717 436.717"
      {...props}
    >
      <g>
        <path
          d="M8.955,242.383c-11.94-11.939-11.94-31.294,0-43.24L196.74,11.357c5.967-5.961,13.793-8.952,21.619-8.952
		c7.822,0,15.648,2.985,21.618,8.952l187.779,187.785c11.939,11.946,11.939,31.301,0,43.24c-11.945,11.945-31.31,11.945-43.255,0
		L218.359,76.237L52.207,242.383C40.261,254.322,20.898,254.322,8.955,242.383z M239.977,194.322
		c-5.97-5.961-13.796-8.952-21.618-8.952c-7.826,0-15.652,2.991-21.619,8.952L8.955,382.107c-11.94,11.945-11.94,31.31,0,43.249
		c11.943,11.939,31.306,11.939,43.252,0l166.152-166.151l166.148,166.151c11.945,11.939,31.31,11.939,43.255,0
		c11.939-11.945,11.939-31.31,0-43.255L239.977,194.322z"
        />
      </g>
    </svg>
  )
}
